import { useQuery } from '@tanstack/react-query';

type OAuthConnectionStatus = {
  connected: boolean;
};

export const useMicrosoftEmailConnectionStatus = (enabled = true) => {
  const { data, isLoading, isError, refetch } = useQuery<OAuthConnectionStatus>({
    queryKey: [
      'oauth',
      'connection-status',
      { platform: 'MICROSOFT', functionality: 'EMAIL_SEND' },
    ],
    enabled,
    staleTime: 60000,
    // A failed check reads as "not connected" and shows the connect button, so recover from
    // transient failures (backend still booting locally, network blips) by re-asking whenever
    // the sidebar remounts or the window regains focus, and by polling while the check is
    // failing — default retries give up before a local backend finishes booting.
    refetchOnMount: 'always',
    refetchOnWindowFocus: true,
    refetchInterval: query => (query.state.status === 'error' ? 10000 : false),
  });

  return {
    connected: data?.connected ?? false,
    isLoading,
    isError,
    refetch,
  };
};
